import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { CheckCircle2, WifiOff } from "lucide-react";
import { VehicleSilhouette, typeStyle } from "./VehicleSilhouette";

export default function FrotaCard({ vehicle, index = 0, onClick }) {
  const { t } = useTranslation();
  const ts = typeStyle(vehicle.vehicle_type);
  const brand = vehicle.brand || "—";
  const model = vehicle.model || vehicle.subfamilia || "—";
  const year = vehicle.matriculacion ? String(vehicle.matriculacion).slice(0, 4) : "—";
  const active = vehicle.has_gps_active;

  return (
    <motion.button
      type="button"
      onClick={onClick}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, delay: index * 0.03 }}
      data-testid={`frota-card-${vehicle.plate}`}
      className="text-left group relative overflow-hidden rounded-2xl border hairline bg-white hover:shadow-xl transition-all duration-300 hover:-translate-y-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-salnes-emerald"
    >
      <div className={`${ts.bg} ${ts.fg} px-5 pt-5 pb-3 flex items-center gap-4`}>
        <VehicleSilhouette type={vehicle.vehicle_type} className="w-20 h-14 shrink-0" />
        <div className="min-w-0 flex-1">
          <div className="text-[10px] uppercase tracking-[0.22em] opacity-80">
            {t(`fase8.frota.type_${vehicle.vehicle_type || "outro"}`)}
          </div>
          <div className="font-serif text-lg leading-tight truncate">
            {brand}
          </div>
          <div className="text-xs opacity-80 truncate">{model}</div>
        </div>
      </div>

      <div className="px-5 py-4 space-y-2">
        <div className="flex items-center justify-between text-xs">
          <span className="text-salnes-stone">{t("fase8.frota.card_year")}</span>
          <span className="text-salnes-ink font-medium">{year}</span>
        </div>
        <div className="flex items-center justify-between text-xs">
          <span className="text-salnes-stone">{t("fase8.frota.card_fuel")}</span>
          <span className="text-salnes-ink font-medium">
            {t(`fase8.frota.fuel_${vehicle.fuel_type || "diesel_b7"}`, vehicle.fuel_type)}
          </span>
        </div>
        <div className="flex items-center justify-between text-xs">
          <span className="text-salnes-stone">{t("fase8.frota.card_euro")}</span>
          <span className="text-salnes-ink font-medium">
            {vehicle.euro_emission_class || "—"}
          </span>
        </div>

        <div className="pt-2 border-t hairline flex items-center justify-between">
          <span className="text-[10px] uppercase tracking-[0.18em] text-salnes-stone font-mono">
            {vehicle.plate}
          </span>
          {active ? (
            <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.18em] text-salnes-emerald">
              <CheckCircle2 size={12} strokeWidth={2} /> {t("fase8.frota.card_gps_on")}
            </span>
          ) : (
            <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.18em] text-salnes-stone">
              <WifiOff size={12} strokeWidth={2} /> {t("fase8.frota.card_gps_off")}
            </span>
          )}
        </div>
      </div>
    </motion.button>
  );
}
